import React, { useCallback } from "react";
import ReactSelect from "react-select";
import ReactTable from "@dhn/components/molecules/data-table";
import { Button, Col, Input, Label, Row, TabPane } from "reactstrap";
import AsyncSelect from "react-select/async";
import { isEmpty } from "lodash";

export default function Medicaments({
  loadMedicines,
  onChange,
  subTabMedicaments,
  handleAddMedicament,
  inputRef,
  isLoading,
  pageEdit,
  addToast,
  isPageModalHistory,
  handleSelectMedicine  
}) {
  const {
    selectedRecipeTipe,
    recipeTypes,
    quantity,
    frecuency,
    frecuencyDaysHours,
    duration,
    durationDaysWeeksMonths,
    doctorNote,
    selectedMedicament,
    appointmentHistoryMedicalPrecription: { precriptionDetails, ...rest } = {},
  } = subTabMedicaments;

  const getMultiplier = useCallback(() => {
    let multipler = 0;
    switch (frecuencyDaysHours) {
      case "Dias":
        multipler = (1 * quantity) / frecuency;
        break;
      case "Horas":
        multipler = (24 * quantity) / frecuency;
        break;
      default:
        multipler = 0;
    }

    switch (durationDaysWeeksMonths) {
      case "Dias":
        multipler *= 1 * quantity * duration;
        break;
      case "Semanas":
        multipler *= 7 * quantity * duration;
        break;
      case "Meses":
        multipler *= 30 * quantity * duration;
        break;
      default:
        multipler *= 1;
    }

    return Math.round(multipler || 0);
  }, [
    duration,
    durationDaysWeeksMonths,
    frecuency,
    frecuencyDaysHours,
    quantity,
  ]);

  const handleRemovePrescriptionDetail = (medicineId) => {
    if (pageEdit && precriptionDetails?.length === 1) {
      addToast("La Prescripcion debe contener al menos un medicamento!!", {
        appearance: "error",
        autoDismiss: true,
      });
      return;
    }
    const data = precriptionDetails?.filter(
      (item) => item?.medicine?.id !== medicineId
    );
    onChange(
      "tabPrescription",
      { ...rest, precriptionDetails: data },
      "subTabMedicaments",
      "appointmentHistoryMedicalPrecription"
    );
  };

  return (
    <TabPane tabId={1} className="border-0">
      <div className="animated fadeIn">
        <div hidden={isPageModalHistory}>
          <Row form>
            <Col md={3}>
              <Label>Tipo de Receta:</Label>
              <ReactSelect
                placeholder="Seleccionar Tipo de Receta"
                getOptionValue={(item) => item}
                getOptionLabel={(item) => item.name}
                value={isEmpty(selectedRecipeTipe) ? null : selectedRecipeTipe}
                options={recipeTypes}
                onChange={(item) =>
                  onChange(
                    "tabPrescription",
                    item,
                    "subTabMedicaments",
                    "selectedRecipeTipe"
                  )
                }
              />
            </Col>
            <Col md="3">
              <Label>Medicamentos:</Label>
              <AsyncSelect
                placeholder="Buscar Medicamentos"
                defaultOptions
                getOptionLabel={(item) => item.name}
                getOptionValue={(item) => item}
                value={isEmpty(selectedMedicament) ? null : selectedMedicament}
                onChange={handleSelectMedicine}
                // onInputChange={handleStaffChange}
                loadOptions={loadMedicines}
              />
            </Col>
          </Row>
          <Row form className="my-4">
            <Col md="1">
              <Label>Cantidad:</Label>
              <Input
                type="number"
                min={1}
                value={quantity || ""}
                onKeyDown={(e) => e.key === "-" && e.preventDefault()}
                onChange={({ target: { value } }) =>
                  onChange(
                    "tabPrescription",
                    parseInt(value),
                    "subTabMedicaments",
                    "quantity"
                  )
                }
              />
            </Col>
            <Col md="1">
              <Label>Frecuencia:</Label>
              <Input
                type="number"
                min={1}
                onKeyDown={(e) => e.key === "-" && e.preventDefault()}
                value={frecuency || ""}
                onChange={({ target: { value } }) =>
                  onChange(
                    "tabPrescription",
                    parseInt(value),
                    "subTabMedicaments",
                    "frecuency"
                  )
                }
              />
            </Col>
            <Col md="2">
              <Label>Horas/Dias:</Label>
              <ReactSelect
                options={[
                  {
                    label: "Dias",
                    value: "Dias",
                  },
                  {
                    label: "Horas",
                    value: "Horas",
                  },
                ]}
                value={
                  frecuencyDaysHours ? { label: frecuencyDaysHours } : null
                }
                onChange={(item) =>
                  onChange(
                    "tabPrescription",
                    item.value,
                    "subTabMedicaments",
                    "frecuencyDaysHours"
                  )
                }
              />
            </Col>
            <Col md="1">
              <Label>Duración:</Label>
              <Input
                type="number"
                min={1}
                onKeyDown={(e) => e.key === "-" && e.preventDefault()}
                value={duration}
                onChange={({ target: { value } }) =>
                  onChange(
                    "tabPrescription",
                    parseInt(value),
                    "subTabMedicaments",
                    "duration"
                  )
                }
              />
            </Col>
            <Col md="2">
              <Label>Dias:</Label>
              <ReactSelect
                value={
                  durationDaysWeeksMonths
                    ? { label: durationDaysWeeksMonths }
                    : null
                }
                options={[
                  {
                    label: "Dias",
                    value: "Dias",
                  },
                  {
                    label: "Semanas",
                    value: "Semanas",
                  },
                  {
                    label: "Meses",
                    value: "Meses",
                  },
                ]}
                onChange={(item) => {
                  onChange(
                    "tabPrescription",
                    item.label,
                    "subTabMedicaments",
                    "durationDaysWeeksMonths"
                  );
                }}
              />
            </Col>
            <Col md={{ size: 1 }}>
              <Label>Total:</Label>
              <Input disabled value={getMultiplier()} />
            </Col>
          </Row>
          <Row form>
            <Col md="4">
              <Label>Nota:</Label>
              <Input
                innerRef={inputRef}
                onBlur={({ target: { value } }) =>
                  onChange(
                    "tabPrescription",
                    value,
                    "subTabMedicaments",
                    "doctorNote"
                  )
                }
                onKeyDown={(e) => {
                  if (e.key === "Enter") e.currentTarget.blur();
                }}
                defaultValue={doctorNote || ""}
              />
            </Col>
            <Col md="2" className="d-flex align-items-end">
              <Button
                color="primary"
                onClick={() => handleAddMedicament(getMultiplier())}
                className="btn-color-primary"
              >
                <i className="fa fa-plus"></i>
                {" Agregar"}
              </Button>
            </Col>
          </Row>
        </div>
        <Row form className="mt-4">
          <Col>
            <ReactTable
              data={precriptionDetails}
              defaultPageSize={5}
              loading={isLoading}
              loadingText="Cargando..."
              noDataText="No hay datos disponibles"
              className="-striped -highlight"
              columns={[
                {
                  Header: "Medicamento",
                  minWidth: 250,
                  // accessor: "medicine.name",
                  Cell: ({ original }) =>
                    `${original.medicine.name} ${
                      original.doctorNote ? `(${original.doctorNote})` : ""
                    }`,
                },
                {
                  Header: "Dosis",
                  className: "text-right",
                  accessor: "quantity",
                },
                {
                  Header: "Frecuencia",
                  Cell: ({ original }) =>
                    "Durante " +
                    original.frecuency +
                    " " +
                    original.frecuencyDaysHours,
                },
                {
                  Header: "Duración",
                  minWidth: 150,
                  Cell: ({ original }) =>
                    "Durante " +
                    original.duration +
                    " " +
                    original.durationDaysWeeksMonths,
                },
                {
                  Header: "Total",
                  className: "text-right",
                  accessor: "totalDosis",
                },
                {
                  Header: "Opciones",
                  show: !isPageModalHistory,
                  Cell: ({ original }) => {
                    return (
                      <Button
                        color="danger"
                        type="button"
                        onClick={() =>
                          handleRemovePrescriptionDetail(original?.medicine?.id)
                        }
                        className="btn-color-danger card-header-action"
                      >
                        <i className={"fa fa-trash"} />
                        {"  Borrar"}
                      </Button>
                    );
                  },
                },
              ]}
            />
          </Col>
        </Row>
      </div>
    </TabPane>
  );
}
